import React from 'react';
import { setupHooks, testHooks } from '../data/mock';
import { CoreFeatures } from './CoreFeatures';

export const HooksGrid = ({ activeComponent, onHookClick }) => {
  const getDisplayData = () => {
    if (activeComponent === 'setup') {
      return { title: 'Setup Hooks', subtitle: 'Configure your test environment before the application starts', items: setupHooks, type: 'hooks' };
    } else if (activeComponent === 'test') {
      return { title: 'Test Hooks', subtitle: 'Interact with your running application during test execution', items: testHooks, type: 'hooks' };
    } else {
      return { title: 'Core Features', subtitle: 'The powerful engine that drives NodeBoot Test Framework', items: [], type: 'features' };
    }
  };

  const { title, subtitle, items, type } = getDisplayData();

  return (
    <div className="hooks-grid-section-v2">
      {type === 'hooks' ? (
        <>
          {/* Text Section */}
          <div className="hooks-text-section">
            <h2 className="hooks-title-v2">{title}</h2>
            <p className="hooks-subtitle-v2">{subtitle}</p>
          </div>

          {/* Hooks Cards */}
          <div className="hooks-cards-container">
            {items.map((item) => (
              <div
                key={item.id}
                className="hook-card"
                onClick={() => onHookClick(item)}
              >
                {/* Icon based on category */}
                <div className="hook-card-icon">
                  {item.category === 'setup' ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="3"></circle>
                      <path d="M12 1v6m0 6v6m9-9h-6m-6 0H3"></path>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="9 11 12 14 22 4"></polyline>
                      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>
                  )}
                </div>
                <div className="hook-card-header">
                  <code className="hook-function">{item.name}()</code>
                </div>
                <p className="hook-card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {/* Core Features Header */}
          <div className="hooks-text-section" style={{ marginBottom: '48px' }}>
            <h2 className="hooks-title-v2">{title}</h2>
            <p className="hooks-subtitle-v2">{subtitle}</p>
          </div>
          
          {/* Core Features Cards */}
          <CoreFeatures />
        </>
      )}
    </div>
  );
};
